import { useEffect, useState } from "react";
import { getProvinceByIds } from "../../utils/requests/province";
import styles from './provincelinks.module.scss';
import Link from "next/link";
import { useTranslation } from "react-i18next";

const provinceIds = [ 1, 4, 2, 3, 58, 11, 12, 38, 66, 19];

export const ProvinceLinks = ({searchParamsList, locale, action, category}) => {
    const { t } = useTranslation();
    const [provincesList, setProvincesList] = useState<any>([]);

    
    useEffect(() => {
        getProvinceByIds('th', provinceIds)
            .then((data) => {
                console.log('ProvinceLinks: ', data.data);

                if (data && data.data.length > 0) {
                    debugger;
                    setProvincesList(data.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching provinces:', error);
            });
    }, [searchParamsList]);


    const {
        actionid,
        categoryid,
        province,
        amphur,
        locationtypeid,
        locationid,
        locationbranchid,
        group_category_id,
        subCategoryId
     } = searchParamsList;

    const showProvinceLinks = !province && !amphur && !locationtypeid
        && !locationid 
        && !locationbranchid 
        && !group_category_id 
        && !subCategoryId;

    console.log('ProvinceLinks: ', searchParamsList, showProvinceLinks, provincesList);

    
    if (!showProvinceLinks || provincesList.length === 0) {
        return null;
    }

    return (
        <>
            <div className={styles.header}>{t('provinceLinks.popularProvinces')}</div>
            {
                provincesList.map((province) => {
                    
                    const name = action + ' ' + category + ' '
                    + province[`PROVINCE_NAME_${locale.toUpperCase()}`] || province.PROVINCE_NAME_TH;
                    
                    const link = [
                        action, 
                        category,
                        province[`PROVINCE_NAME_${locale.toUpperCase()}`] || province.PROVINCE_NAME_TH
                    ].join('/');


                    return <div key={name} className={styles.sublink}>
                        <Link href={`/${link}`}>{name}</Link>    
                    </div>

                    // return <div key={province.PROVINCE_ID} >
                    //     <a href={`/${link}`} className="text-blue-500 hover:underline">
                    //         { name }
                    //     </a>
                    // </div>
                })
            }
        </>
    )
}